module.exports = __webpack_public_path__ + "static/undraw_prototyping_process_rswj-59c54b5c53ad54302aa66deaa8975ff4.svg";